import React from 'react';

import loadableFunction from '@loadable/component';

export const loadable = (func, options) => {
  options = { fallback: <div className="loading-indicator" />, ...options };
  return loadableFunction(func, options);
};
